import { UserRoleEnum } from '@core/enums/user_role_enum';

/** Roles allowed to edit a partner's default meter role (My Company page).
 * Checked directly against the caller's role_name (backend does the same) --
 * no auth.feature grant row required, unlike the per-device meter-role editor.
 * Xemex roles are deliberately excluded (RDT-1019): Xemex is not a partner, so it has no
 * default meter role of its own to edit on this page. */
export const DEFAULT_METER_ROLE_EDITOR_ROLES: string[] = [UserRoleEnum.PartnerAdmin];
